<template>
    <div class="index-bg">
      <div class="index-header">
        <img class="logo" src="../../assets/img/logo-xh.png"/>
        <div class="search-cont" @click="searchPage"><van-icon name="sousuo"></van-icon><span>搜索职位/公司…</span></div>
        <van-icon class="history" name="lishi"><span>申请记录</span></van-icon>
      </div>
      <van-swipe class="swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item><img src="../../assets/img/banner.jpg"> </van-swipe-item>
        <van-swipe-item><img src="../../assets/img/banner.jpg"></van-swipe-item>
      </van-swipe>
      <div class="title-01">
        <h2>推荐企业</h2>
        <router-link class="btn-more" to="">全部企业</router-link>
      </div>
      <ul class="company-list">
        <li v-for="item in company" :key="item.index">
          <img :src="item.logo"/>
          <div class="detail-info">
            <h3>{{item.name}}</h3>
            <ul class="feature">
              <li v-for="feature in item.featurelist" :key="feature.index">
                {{feature.detail}}
              </li>
            </ul>
            <ul class="welfare">
              <li v-for="welfare in item.welfarelist" :key="welfare.index">
                {{welfare.detail}}
              </li>
            </ul>
            <div class="jobs">
              在招职位 <span>{{item.jobs}}</span>
            </div>
          </div>
        </li>
      </ul>
      <ul class="company-list-simple">
        <li v-for="item in companySimple" :key="item.index">
          <img :src="item.logo"/>
          <div class="detail-info">
            <h3>{{item.name}}</h3>
            <ul class="feature">
              <li v-for="feature in item.featurelist" :key="feature.index">
                {{feature.detail}}
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="gray-blank">
      </div>
      <div class="title-01">
        <h2>急招职位</h2>
        <router-link class="icon-more" to="">更多 <van-icon name="gengduo"></van-icon></router-link>
      </div>
      <ul class="job-list">
        <li v-for="item in jobs" :key="item.index">
          <div class="detail-info">
            <div class="info-header">
              <h3>{{item.name}} <small>急</small> </h3>
              <span>{{item.wages}}</span>
            </div>
            <ul class="conditionList">
              <li v-for="condition in item.conditionList" :key="condition.index">
                {{condition.detail}}
              </li>
            </ul>
            <ul class="feature">
              <li v-for="feature in item.featurelist" :key="feature.index">
                {{feature.detail}}
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <van-popup v-model="popup" closeable>
        <div class="pop-cont">
          <img src="../../assets/img/popbg.png"/>
          <p>你离心仪的职位只差一份简历</p>
          <van-button type="primary" color="linear-gradient(to right top, #F69B58,#F87342)" round>创建简历</van-button>
        </div>
      </van-popup>
      <navBar></navBar>
    </div>
</template>

<script>
import navBar from './components/navbar'
export default {
  name: 'index',
  components: {
    navBar
  },
  data() {
    return {
      value: '',
      popup: '',
      company: [
        {
          logo: require('@/assets/img/logo1.jpg'),
          name: '腾讯',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          welfarelist: [
            {
              detail: '绩效奖金'
            }, {
              detail: '年底双薪'
            }, {
              detail: '五险一金'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '腾讯',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          welfarelist: [
            {
              detail: '绩效奖金'
            }, {
              detail: '年底双薪'
            }, {
              detail: '五险一金'
            }
          ]
        }, {
          logo: require('@/assets/img/logo1.jpg'),
          name: '腾讯',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          welfarelist: [
            {
              detail: '绩效奖金'
            }, {
              detail: '年底双薪'
            }, {
              detail: '五险一金'
            }
          ]
        }
      ],
      companySimple: [
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo3.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo1.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        }
      ],
      jobs: [
        {
          name: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          name: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          name: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          name: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        }
      ]
    }
  },
  methods: {
    searchPage: function () {
      this.$router.push('/search')
    }
  }
}
</script>

<style lang="less" scoped>
  .index-bg{
    background: url("../../assets/img/indexbg-xh.png") center top no-repeat;
    background-size: 100% auto;
    padding:10px 0;
  }
  /deep/.swipe{
    margin:8px 18px;
    img{
      width: 100%;
      border-radius: 10px;
    }
  }
  .index-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:16px;
    .logo{
      width: 104px;
      height: 24px;
    }
    .search-cont{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color:#fff;
      height: 30px;
      border-radius: 50px;
      background: rgba(255,255,255,.3);
      flex:1;
      margin:0 16px;
      span{
        font-size: 12px;
        margin-left: 10px;
      }
    }
    .history{
      font-size: 18px;
      text-align: center;
      color:#fff;
      margin-top: -4px;
      span{
        font-size: 12px;
        display: block;
        line-height: 1;
        transform: scale(.9);
      }
    }
  }

</style>
